import { isAfter, isBefore } from "date-fns";

import { Brand } from "types";

const promotionStartDate = new Date("2025-04-29T11:00:00+02:00");
const promotionEndDate = new Date("2025-08-26T00:00:00+02:00");

const koisiPromotionEndDate = new Date("2025-08-14T00:00:00+01:00");

export const isAssetPromotionEnabled = (
  assetId: string,
  // eslint-disable-next-line @typescript-eslint/no-unused-vars
  brand: Brand,
): boolean => {
  // LSAN
  if (assetId === "c1e4c1d6-14f5-402b-bb0c-4f0aa5b821d5") {
    return isBefore(new Date(), koisiPromotionEndDate);
  }

  const isAfterPromotionStart = isAfter(new Date(), promotionStartDate);
  const isBeforePromotionEnd = isBefore(new Date(), promotionEndDate);

  return (
    isAfterPromotionStart &&
    isBeforePromotionEnd &&
    [
      "10679918-39c1-4ac7-be9b-9b75bcedf227", //"BOOP"
      "167f2b95-95de-4b29-bbab-5a2ab5a6db39", //"LBLD"
      "2045c99b-7c4c-4be4-bd3d-b71de803b065", //"LCTN"
      "2b2c6df4-819d-4ca0-a331-52fe59050a43", //"LCSM"
      "39fcabed-ebca-4c4b-a052-f919c2ec34e3", //"LMCH"
      "c20c2938-4ef5-437f-8cb8-709f12901fae", //"LMPR"
      "a29d75a0-9c88-41da-8ece-62d53362e77b", //"LVAB"
      "41753207-ae70-459b-8ffc-c7130e04d25d", //"LVJB"
      "65dd7f1e-b262-4e86-8d05-64dc8985d5ab", //"NBPO"
      "74d94f49-8b9b-4cac-a8bc-cef6c560c784", //"LLED"
      "58b8481b-c493-4024-a0dc-a80430c90ce0", //"LGCT"
    ].includes(assetId)
  );
};

export const promotionForAsset = (
  assetId: string,
  brand: Brand,
): Promotion | null =>
  isAssetPromotionEnabled(assetId, brand) ? promotionForBrand(brand) : null;

export const promotionForBrand = (brand: Brand): Promotion | null => {
  if (brand.id === "koisi") {
    if (isBefore(new Date(), koisiPromotionEndDate)) {
      return {
        discount: { type: "fixed", amount: 10 },
        promoCode: "SUMMER",
        startDate: "01/05/2025",
        endDate: "31/08/2025",
        maxNights: 3,
      };
    }
  }

  const isAfterPromotionStart = isAfter(new Date(), promotionStartDate);
  const isBeforePromotionEnd = isBefore(new Date(), promotionEndDate);
  if (
    ["libere", "b48", "naitly"].includes(brand.id) &&
    isAfterPromotionStart &&
    isBeforePromotionEnd
  ) {
    return {
      discount:
        brand.id === "libere"
          ? { type: "upTo", amount: 15 }
          : { type: "fixed", amount: 10 },
      promoCode: "SUMMER",
      startDate: "01/06/2025",
      endDate: "31/08/2025",
      maxNights: 3,
      loyaltyApplies: brand.id === "libere",
    };
  }
  return null;
};

export type Promotion = {
  discount: { type: "fixed" | "upTo"; amount: number };
  promoCode: string;
  startDate: string;
  endDate: string;
  maxNights: number;
  translateKey?: string;
  loyaltyApplies?: boolean;
};
